import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { tPatientModel, tPatientModel_Encrypted } from '../models/tPatientModel';
import { isNullOrUndefined } from 'util';
import { TranslateService } from '@ngx-translate/core';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';


@Injectable({
    providedIn: 'root'
  })
  export class tPatientService {

    // ------- Patient Dialog use

    // selectedPatient : tPatientModel = new tPatientModel();
    // get getFromDialog_SelectedPatient(){
    //   return this.selectedPatient;
    // }

    // private selected_patient_booking_Source = new BehaviorSubject('');
    // current_selected_patient_booking = this.selected_patient_booking_Source.asObservable();

    // shareSelectedPatient(selectedPatientID: string) {
    //   this.selected_patient_booking_Source.next(selectedPatientID);
    // }

    // ------- End Patient Dialog use

    constructor(private http: HttpClient, public translate: TranslateService) { }

    private selected_shopID_Source = new BehaviorSubject('<未選取>');
    current_shopID = this.selected_shopID_Source.asObservable();

    private selected_patientID_Source = new BehaviorSubject('<未選取>');
    current_patientID = this.selected_patientID_Source.asObservable();



    private tab1_Source = new BehaviorSubject('');
    current_tab1 = this.tab1_Source.asObservable();

    private tab2_Source = new BehaviorSubject('');
    current_tab2 = this.tab2_Source.asObservable();

    private tab3_Source = new BehaviorSubject('');
    current_tab3 = this.tab3_Source.asObservable();

    private tab4_Source = new BehaviorSubject('');
    current_tab4 = this.tab4_Source.asObservable();

    private tab5_Source = new BehaviorSubject('');
    current_tab5 = this.tab5_Source.asObservable();

    baseurl: string = AppSettings.BaseURI;


    readonly pathName = '/tPatientModels';

    readonly fullPath = this.baseurl + this.pathName;

    changeMessage(systemPatientSetting: tPatientModel) {

      let shopIDStr = '';
      let patientIDStr = '';


      if (!isNullOrUndefined(systemPatientSetting.shopID)) {
        shopIDStr = systemPatientSetting.shopID.toString();
      }
      if (!isNullOrUndefined(systemPatientSetting.patientID)) {
        patientIDStr = systemPatientSetting.patientID.toString();
      }

      this.selected_shopID_Source.next(shopIDStr);
      this.selected_patientID_Source.next(patientIDStr);
    }




    getAllData() {
      return this.http.get<tPatientModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }

    getAllDataWithPatientTypeInfo() {
      return this.http.get<tPatientModel_Encrypted[]>(this.baseurl + this.pathName  + '/' + 'WithPatientTypeInfo').pipe(shareReplay(1));
    }


    getCount() {
      return this.http.get<number>(this.baseurl + this.pathName  + '/' + 'Count').pipe(shareReplay(1));
    }

    getAllDataWithPatientTypeInfoByRange(rowFrom: number, nextRows: number, data: any, isSearch: string) {
      // tslint:disable-next-line:max-line-length
      return this.http.post<tPatientModel_Encrypted[]>(this.baseurl + this.pathName  + '/' + 'WithPatientTypeInfoByRange' + '/'
      + rowFrom + '/' + nextRows + '/' + isSearch, data).pipe(shareReplay(1));
    }

    getAllDataWithPatientTypeInfoByRangeV2(rowFrom: number, nextRows: number, data: any, isSearch: string) {
      return this.http
        .post<tPatientModel_Encrypted[]>(
          `${this.fullPath}/WithPatientTypeInfoByRange/v3/${rowFrom}/${nextRows}/${isSearch}`,
          data
        )
        .pipe(shareReplay(1));
    }


    getDataById(shopID: string, patientID: string) {
      return this.http.get<tPatientModel_Encrypted>(this.baseurl + this.pathName + '/' + shopID + '/' + patientID).pipe(shareReplay(1));
      // return this.http.get<tPatientModel>(this.baseurl + this.pathName + '/' + mediCode + '/' + mediCateCode);
    }

    addData(data: tPatientModel_Encrypted) {
      return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted', data).pipe(shareReplay(1));
    }
    newPatientCheckIn(data: any) {
      return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted/checkIn/newPatient/', data).pipe(shareReplay(1));
    }

    checkPatientHKID(data: any) {
      return this.http.post(this.baseurl + this.pathName + '/' + 'CheckHKID/', data);
    }

    deleteData(data: tPatientModel) {
      return this.http.delete(this.baseurl + this.pathName + '/' + 'Formatted' + '/' + data.shopID + '/' + data.patientID);
    }

    updateData(data: tPatientModel_Encrypted) {
      return this.http.put(this.baseurl + this.pathName  + '/' + 'Formatted/main' + '/' + data.shopID + '/' + data.patientID, data);
    }

    updateDataConsult(data: tPatientModel_Encrypted) {
      return this.http.put(this.baseurl + this.pathName  + '/' + 'Formatted/consult' + '/' + data.shopID + '/' + data.patientID, data);
    }

    updateDataBilling(data: tPatientModel_Encrypted) {
      return this.http.put(this.baseurl + this.pathName  + '/' + 'Formatted/billing' + '/' + data.shopID + '/' + data.patientID, data);
    }

    updatePatientDiseaseRemark1(data: any){
      return this.http.put(this.baseurl + this.pathName  + '/' + 'diseaseRemark', data);
    }
    updatePatientHeightWeight(data: any){
      return this.http.put(this.baseurl + this.pathName  + '/' + 'patientHeightWeight', data);
    }
    getPatientDiseaseRemark1(patientID: string){
      return this.http.get<ResultModel>(this.baseurl + this.pathName  + '/' + 'diseaseRemark'+ '/' + patientID);
    }

    getLabelPrint(patientID:string,labelID:Number){
      return this.http.get<ResultModel>(this.baseurl + this.pathName  + `/labelPrint/${patientID}/${labelID}`);
    }

  }

  export class ResultModel{
    message:string;
    data:any;
  }
